import React, { useContext } from 'react';
import { useLocation, useNavigate, Navigate } from "react-router";
import { AppContext } from '../../context/app-context';
import { SocialLoginContext } from '../../context/social-login-context';
import { getLandingRedirectPathForUser } from '../../routing/route-utils';
import SignUp from './SignUp';
import { REDIRECT_REFERRER } from '../../components/constants/local-storage-constants';
import { AccountType, LOGIN_PATH } from '../../components/constants/securspace-constants';
import PageSEO from '../../components/seo/PageSEO';

// Sign-up stays out of search through noindex. robots.txt no longer blocks /buyer-signup
// and /supplier-signup, so Google can read it (securspace-ui#3107); /customer-signup and
// /partner-signup redirect here too. No canonical: it would contradict the noindex.
const SIGN_UP_SEO = {
    [AccountType.BUYER]: {
        title: 'Sign Up as a Buyer | SecurSpace',
        description: 'Create a SecurSpace buyer account to reserve truck parking and container storage space.',
    },
    [AccountType.SUPPLIER]: {
        title: 'Sign Up as a Supplier | SecurSpace',
        description: 'Create a SecurSpace supplier account to list your location for truck and container parking.',
    },
};

const ContextualSignUp = (props) => {
    const appContext = useContext(AppContext)
    const {type = AccountType.BUYER} = props;
    const { user, loadingUserDetails, updateUser } = appContext

    const socialLoginContext = useContext(SocialLoginContext)
    const { socialLogin, setSocialLoginUser, clearSocialLoginUser } = socialLoginContext

    const location = useLocation()
    const history = useNavigate()

    const redirectPath = getLandingRedirectPathForUser(user)

    const updateUserAndRedirect = (user) => {
        updateUser(user, history, localStorage.getItem(REDIRECT_REFERRER) ? localStorage.getItem(REDIRECT_REFERRER) : null);
    }

    let content

    if (loadingUserDetails) {
        content = <div /> //todo za -- loading component
    } else if(user && user.id) {
        content = <Navigate to={redirectPath} />
    } else {
        content = <SignUp
            type={type}
            handleNavigateToLogin={() => history(LOGIN_PATH)}
            handleAccountChange={updateUserAndRedirect}
            socialLoginTemporaryUser={socialLogin}
            setSocialLoginUser={setSocialLoginUser}
            clearSocialLoginUser={clearSocialLoginUser}
            location={location}
        />
    }

    return <>
        <PageSEO {...SIGN_UP_SEO[type]} noindex />
        {content}
    </>;
};

export default ContextualSignUp;
